import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CurrentUserService } from '@shared/services/current-user.service';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private currentUserService: CurrentUserService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.authData$.pipe(
      first(),
      map((authData) => {
        // console.log('isAuth guard', route, state);
        if (!authData?.isLoggedIn) {
          return this.router.createUrlTree(['/auth/login'], {
            queryParams: { returnUrl: state.url },
            queryParamsHandling: 'merge',
          });
        }
        return true;
      }),
    );
  }
}
